var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticClass:"rounded-lg",attrs:{"contain":"","height":"480","src":"/img/mario.png"}}),_c('h1',{staticClass:"mt-8 display-4 text-center font-weight-bold"},[_vm._v("Mario Novak")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }